module.exports = __webpack_public_path__ + "img/empty-state-to-do.2361895b.svg";